import { AccountRecord } from '@trustero/trustero-api-web/lib/account/account_pb'

/**
 * What an account is called in the exports' Entity column: its company name, or its account id when
 * it has none.
 *
 * The browser-side twin of table.OrgNameOrID, which is what stamps the same column for a child
 * account's rows. Both spellings have to agree — the importer matches a row's Entity against the
 * importing account to decide whether the row belongs to it.
 */
export const entityNameFor = (account?: AccountRecord): string =>
  account?.getOrgname() || account?.getId() || ''
